import React from 'react';
import { useI18n } from '../i18n/I18nContext';

function DeleteUserModal({ user, onDeleteUser, onClose }) {
    const { t } = useI18n();
    const handleDelete = () => {
        onDeleteUser(user.id);
    };

    return (
        <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50'>
            <div className='bg-white p-4 rounded shadow-lg w-full max-w-md'>
                <h3 className='text-xl font-bold mb-4'>{t('user.deleteTitle')}</h3>
                <p className='mb-4'>{t('user.deleteConfirm', { name: user.name })}</p>
                <div className='flex justify-end gap-2'>
                    <button onClick={onClose} className='bg-gray-500 text-white py-1 px-3 rounded'>{t('common.close')}</button>
                    <button onClick={handleDelete} className='bg-red-500 text-white py-1 px-3 rounded'>{t('common.delete')}</button>
                </div>
            </div>
        </div>
    );
}

export default DeleteUserModal;


